module.exports = __webpack_public_path__ + "img/84.6.CODm.18bfdee7.png";